import React from "react";
import AnimatedChatDemo from "./AnimatedChatDemo";

/** Shared left panel for auth split layout. */
const AuthLeftPanel = ({ variant = "login" }) => (
  <div className="auth-split-left">
    <div className="auth-left-main auth-left-enter">
      <h1
        className="auth-hero cw-welcome-enter-item"
        style={{ "--enter-delay": "0ms" }}
      >
        The Oracle HCM expert that never sleeps.
      </h1>
      <p
        className="auth-hero-sub cw-welcome-enter-item"
        style={{ "--enter-delay": "60ms" }}
      >
        Instant answers. Release-aware. Specific to your implementation.
      </p>

      {variant === "login" ? (
        <div
          className="auth-chat-preview cw-welcome-enter-item"
          style={{ "--enter-delay": "120ms" }}
          aria-hidden="true"
        >
          <div className="auth-preview-chrome">
            <span>edge · briefing</span>
          </div>
          <AnimatedChatDemo compact />
        </div>
      ) : (
        <div
          className="auth-register-benefits cw-welcome-enter-item"
          style={{ "--enter-delay": "120ms" }}
        >
          <p className="auth-benefits-label">What you get with Edge AI</p>
          <div className="auth-benefit">
            <div className="auth-benefit-icon">✓</div>
            <div>
              <h4>Instant Oracle HCM answers</h4>
              <p>
                Get precise answers to implementation and configuration questions in seconds.
              </p>
            </div>
          </div>
          <div className="auth-benefit">
            <div className="auth-benefit-icon">✓</div>
            <div>
              <h4>Release-aware responses</h4>
              <p>
                Always up to date with Oracle HCM 25C and 25D release notes and changes.
              </p>
            </div>
          </div>
          <div className="auth-benefit">
            <div className="auth-benefit-icon">✓</div>
            <div>
              <h4>Your company&apos;s docs, privately indexed</h4>
              <p>
                Upload your Oracle implementation guides and get answers specific to your exact setup.
              </p>
            </div>
          </div>
          <div className="auth-benefit">
            <div className="auth-benefit-icon">✓</div>
            <div>
              <h4>Canadian data residency</h4>
              <p>All data stored on Canadian servers. Your data never leaves Canada.</p>
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
);

export default AuthLeftPanel;
